<template>
  <div class="grid-container grid-x search-rail-enchanced">
    <div :class="{ 'rail-column': isBcom }">
      <Logo />
    </div>
    <div
      :class="{
        'rail-middle-column': isBcom,
        'rail-stretch-column': !isBcom,
        'convo-commerce': isAiScriptEnabled,
      }"
    >
      <Search />
    </div>
    <div :class="{ 'rail-column': isBcom }" class="nowrap grid-x align-right align-middle rail-column-wrapper">
      <template v-if="isDomestic">
        <Profile />
        <YourStore />
        <Registry />
      </template>
      <template v-else>
        <OrderTracking v-if="!isBcom" />
        <Shipping />
      </template>
      <BagIcon class="rail-btn-hover margin-left-xs" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Logo from '../common/Logo.common';
import Search from '../search/Search.common';
import BagIcon from '../common/BagIcon.common';
import Profile from '../search-rail/Profile.common';
import YourStore from '../search-rail/YourStore.common';
import Registry from '../search-rail/Registry';
import Shipping from '../search-rail/Shipping.common';
import OrderTracking from '../search-rail/OrderTracking.common';
import useAskAiVisibility from '~/composables/useAskAiVisibility';

const envProps = useEnvProps();
const pageData = usePageData();
const { isAiScriptEnabled } = useAskAiVisibility();

const { isBcom } = envProps;
const isDomestic = computed(() => pageData.navigation.context.isDomestic);
</script>

<style lang="scss">
$rail-height: 40px;

.rail-btn-hover {
  min-height: $rail-height;
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 0;

  &::before,
  &::after {
    display: block;
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 5px;
  }

  &::before {
    top: -5px;
  }

  &::after {
    bottom: -5px;
    border-bottom: 2px solid transparent;
  }

  &:hover {
    cursor: pointer;

    &::after {
      border-color: #000;
    }
  }
}

.rail-btn-nowrap {
  flex-wrap: nowrap;
  white-space: nowrap;
}
</style>

<style lang="scss" scoped>
.rail-column {
  flex: 1;
}

.rail-middle-column {
  flex-shrink: 1;
  flex-grow: 1;
  flex-basis: auto;
  margin: 0 16px;
}
</style>

<style lang="scss" brand="mcom" scoped>
$afterMLarge: map-get($breakpoints, mlarge) + 1px;

.rail-stretch-column {
  flex: 1 1 auto;
  margin: 0 32px;
}

@media screen and (min-width: $afterMLarge) {
  .rail-middle-column {
    flex-grow: 0;
  }
}

.search-rail-enchanced {
  padding-top: 20px;
  padding-bottom: 4px;

  &.grid-x {
    flex-flow: row nowrap; // help prevent wrapping around 1024px
  }
}

.rail-column-wrapper {
  width: 451px; // help prevent search bar from readjusting onload
}
</style>

<style lang="scss" brand="bcom" scoped>
.search-rail-enchanced {
  padding-top: 16px;
  padding-bottom: 8px;
}

.rail-middle-column {
  flex-grow: 1;
  flex-basis: 0;

  &.convo-commerce {
    @include breakpoint(mlarge only) {
      flex-basis: 330px;
    }
  }
}

@include breakpoint(mlarge up) {
  .rail-middle-column {
    flex-grow: 0;
    flex-basis: 397px;
  }
}

@include breakpoint(xlarge up) {
  .rail-middle-column {
    flex-basis: 480px;
  }
}
</style>

<style lang="scss" brand="bcom">
.search-rail-enchanced {
  .nav-search-wrapper {
    width: 100%;
  }
}
</style>
